// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileLabel_wrapper__vKjHN","avatar":"ProfileLabel_avatar__EsSSv","name":"ProfileLabel_name__coj6P"};